/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Editor_Locale_ScopeInputs */

const cs_blog_editor_locale_scope = /** @type {(inputs: Blog_Editor_Locale_ScopeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Úprava jazykové verze ${i?.locale}.`)
};

const en_blog_editor_locale_scope = /** @type {(inputs: Blog_Editor_Locale_ScopeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editing the ${i?.locale} language version.`)
};

/**
* | output |
* | --- |
* | "Editing the {locale} language version." |
*
* @param {Blog_Editor_Locale_ScopeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_editor_locale_scope = /** @type {((inputs: Blog_Editor_Locale_ScopeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Editor_Locale_ScopeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_editor_locale_scope(inputs)
	return cs_blog_editor_locale_scope(inputs)
});